module.exports = __webpack_public_path__ + "img/stepEarn2.4176b300.png";